module.exports = __webpack_public_path__ + "img/spin_btn.af99ccec.png";